import { APP_DOMAIN, VERCEL_URL, NODE_ENV } from './process'

export const IS_DEV = NODE_ENV === 'development'

export const DOMAIN = APP_DOMAIN || VERCEL_URL

export const COOKIE_DOMAIN = IS_DEV ? 'localhost' : `.${DOMAIN}`
